import React from 'react';
import { connect } from "react-redux";
import {Button, Card, Container, Form, Icon, Message} from "semantic-ui-react";
import {
    addNewVolumeTierV2, deleteVolumeTierV2,
    editFlatPricingV2,
    editVolumePricingV2,
    selectCountryForPricingV2, selectPricingSchemeV2,
} from "../actions/PricingTablesActions";
import _ from "lodash";
import COUNTRIES from "../../../common/resources/countries.json";
import Select from "react-select";
import countriesData from "../../../common/resources/countries.json";
import lodash from "lodash/core";
import * as Validation from "../../../common/utils/Validation";

export class AddEditCountryPricingFormV2 extends React.Component {

    countryLabel = (code) => {
        return _.result(_.find(COUNTRIES, {
            'value': code
        }), 'label');
    }

    handlePricingSchemeSelect = ( pricingScheme ) => {
        this.props.selectPricingSchemeValue({ pricingScheme });
    }

    handleCountrySelect = ( country ) => {
        this.props.selectCountryValue({ country });
    }

    handleFlatPricingChange = (e, {value}) => {
        this.props.editFlatPriceForCountry(value)
    }

    handleVolumePricingChange = (e, {value, name, idx}) => {
        this.props.editVolumePriceForCountry(value, name, idx);
    }

    handleAddVolumeTier = () => {
        this.props.addNewVolumeTier();
    }

    handleDeleteVolumeTier = () => {
        this.props.deleteVolumeTier()
    }

    handleDismiss = () => {
        Validation.clearMessages();
    }

    render() {

        const {
            countryPricingObject, addCountryPricingModalOpen, addPricingSchemeModalOpen, pricingSchemeOptions,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification
        } = this.props;

        return(
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <Form.Group widths="equal">
                                    {addPricingSchemeModalOpen
                                        ? (
                                            <Form.Field required={addPricingSchemeModalOpen}>
                                                <label>Pricing Scheme</label>
                                                <Select
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    options={pricingSchemeOptions}
                                                    placeholder="Select A Pricing Scheme"
                                                    value={lodash.find(pricingSchemeOptions, {
                                                        value: countryPricingObject.pricing_scheme
                                                    })}
                                                    onChange={this.handlePricingSchemeSelect}
                                                />
                                            </Form.Field>
                                        )
                                        : (
                                            <Form.Input
                                                disabled
                                                type="text"
                                                label="Pricing Scheme"
                                                value={countryPricingObject.pricing_scheme}
                                            />
                                        )

                                    }
                                    {addCountryPricingModalOpen || addPricingSchemeModalOpen
                                        ? (
                                            <Form.Field required>
                                                <label>Country</label>
                                                <Select
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    options={countriesData}
                                                    placeholder="Select Country"
                                                    value={lodash.find(countriesData, {
                                                        value: countryPricingObject.country_code
                                                    })}
                                                    onChange={this.handleCountrySelect}
                                                />
                                            </Form.Field>
                                        )
                                        : (
                                            <Form.Input
                                                disabled
                                                type="text"
                                                label="Country"
                                                value={countryPricingObject.country_code + ' - ' +
                                                    this.countryLabel(countryPricingObject.country_code)}
                                                name="country_code"
                                            />
                                        )
                                    }
                                {/* if the pricing scheme is flat, we directly expose the pricing input on the form and
                                 capture the value accordingly.
                                 Even though Input types are marked as number, semantic/fomantic input component sends
                                 the value as string. This String is parsed into native js data type Number based when
                                 it is assigned in the reducer.
                                 */}
                                    {countryPricingObject.pricing_scheme === 'FLAT'
                                        ? (
                                            <Form.Input
                                                required
                                                type='number'
                                                step="0.1"
                                                label="Price"
                                                placeholder="$"
                                                value={countryPricingObject.pricing_json[0].price}
                                                name="price"
                                                onChange={this.handleFlatPricingChange}
                                            />
                                        )
                                        : null}
                                </Form.Group>
                                {countryPricingObject.pricing_scheme !== "FLAT"
                                    ? (
                                        countryPricingObject.pricing_json.map((p, idx) => {
                                            return (
                                                <div className="volume-country-pricing-edit">
                                                    <Form.Group widths="equal" >
                                                        <Form.Input
                                                            disabled={!addPricingSchemeModalOpen}
                                                            type="number"
                                                            label="Min."
                                                            placeholder="Min."
                                                            value={p.min}
                                                            name={"min"}
                                                            idx={idx}
                                                            onChange={this.handleVolumePricingChange}
                                                        />
                                                        <Form.Input
                                                            disabled={!addPricingSchemeModalOpen}
                                                            type="number"
                                                            label="Max."
                                                            placeholder="Max."
                                                            value={p.max}
                                                            name={"max"}
                                                            idx={idx}
                                                            onChange={this.handleVolumePricingChange}
                                                        />
                                                        <Form.Input
                                                            type='number'
                                                            step="0.1"
                                                            label="Price"
                                                            placeholder="$"
                                                            value={p.price}
                                                            name={"price"}
                                                            idx={idx}
                                                            onChange={this.handleVolumePricingChange}
                                                        />
                                                        {/* Only allow to delete from the last tier upwards and
                                                        do not allow to delete if there is only one tier left. */}
                                                            <div style={{alignSelf: "center",
                                                                paddingTop: "20px", cursor: "pointer"}}>
                                                                <Icon
                                                                    disabled={idx === 0 ||
                                                                        idx !== countryPricingObject.pricing_json.length - 1}
                                                                    idx={idx}
                                                                    size={"large"}
                                                                    name={"trash alternate"}
                                                                    onClick={this.handleDeleteVolumeTier}
                                                                />
                                                            </div>

                                                    </Form.Group>
                                                </div>
                                            )
                                        })
                                    )
                                    : null
                                    }
                                {addPricingSchemeModalOpen && countryPricingObject.pricing_scheme !== "FLAT"
                                    ? (
                                        <div>
                                            <Button
                                                content={"Add Volume Tier"}
                                                onClick={this.handleAddVolumeTier}
                                            />
                                        </div>
                                    )
                                    : null

                                }
                            </Card.Content>
                        </Card>
                    </Form>

                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "30px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    // hidden={formWarning}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>
            </div>
        )

    }
}

const mapStateToProps = (state) => ({
    pricingTableObjectV2: state.billing.addEditPricingTable.pricingTableObjectV2,

    countryPricingObject: state.billing.addEditCountryPricing.countryPricingObject,
    pricingSchemeOptions: state.billing.addEditCountryPricing.pricingSchemeOptions,
    addCountryPricingModalOpen: state.billing.addEditCountryPricing.addCountryPricingModalOpen,
    addPricingSchemeModalOpen: state.billing.addEditCountryPricing.addPricingSchemeModalOpen,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    editFlatPriceForCountry: (value) => {dispatch(editFlatPricingV2(value))},
    editVolumePriceForCountry: (value, name, idx) => {dispatch(editVolumePricingV2(value, name, idx))},

    selectCountryValue: ({ country }) => {dispatch(selectCountryForPricingV2({ country }))},
    selectPricingSchemeValue: ({ pricingScheme }) => {
        dispatch(selectPricingSchemeV2({ pricingScheme }))},
    addNewVolumeTier: () => {dispatch(addNewVolumeTierV2())},
    deleteVolumeTier: () => {dispatch(deleteVolumeTierV2())},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddEditCountryPricingFormV2);
